var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{fill:#f9f7e1;}.cls-2,.cls-3{stroke:#333;stroke-miterlimit:10;stroke-width:2px;}.cls-3{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_108",
    "data-name": 108,
    className: "cls-2",
    d: "M46.19,2.24c13.36-.88,18.68,11.78,27,19.35C79.63,27.4,89.91,32.51,88.3,42.91c-2,12.89-17,11.44-26,15.37C53.63,62,53.4,70.44,46.48,79.88,39,90,24.94,99.91,19.05,97,4.57,89.93,24.59,3.65,46.19,2.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "detail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crevice",
    className: "cls-3",
    d: "M70.83,38.51a24.57,24.57,0,0,1-17.66-3.72,24.15,24.15,0,0,1-9.26-12.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crevice-2",
    "data-name": "crevice",
    className: "cls-3",
    d: "M48.41,31a48.73,48.73,0,0,1-4.5,28.51A47.47,47.47,0,0,1,31.56,74.91"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cat_307"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3,
    y: -59,
    width: 100,
    height: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog108);
export default __webpack_public_path__ + "static/media/dog_108.400893e9e5805072fea82698fd48bec7.svg";
export { ForwardRef as ReactComponent };